import OutputView from '@components/block/OutputView/OutputView';
import { Box } from '@mui/material';

interface DpoDocumentViewerProps {
  localQuestionnaireId?: string;
  documentNumber?: number;
  placeholder?: string;
}

export function DpoDocumentViewer({ 
  localQuestionnaireId, 
  documentNumber,
  placeholder = 'No document selected'
}: DpoDocumentViewerProps) {
  
  if (!localQuestionnaireId) {
    return (
      <Box 
        className="flex-1 overflow-auto bg-[#F9F9F9] rounded-none border-2 border-t-0 border-[#E3E3E3] flex flex-col"
      >
        <Box className="p-5 flex-1 overflow-auto bg-white m-1 rounded-none border-[#E3E3E3]">
          <Box className="text-[#666] text-sm leading-[1.6]">
            <p className="m-0 text-[#999]">{placeholder}</p>
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box 
      className="flex-1 overflow-auto bg-[#F9F9F9] rounded-none border-2 border-t-0 border-[#E3E3E3] flex flex-col"
    >
      <Box className="p-0 flex-1 overflow-auto bg-white m-0 rounded-none border-[#E3E3E3]">
        <OutputView
          localQuestionnaireId={localQuestionnaireId}
          documentNumber={documentNumber}
          onlyContent={false}
          locked={false}
        />
      </Box>
    </Box>
  );
}
